import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {SignInComponent} from "./sign-in/sign-in.component";
import {GuestGuard} from "../../guards/guest.guard";
import {HttpClientModule} from "@angular/common/http";

export const authRoutes: Routes = [

  {
    path: 'auth',
    canActivate: [GuestGuard],
    canActivateChild: [GuestGuard],
    children: [{
      path: "login",
      component: SignInComponent,
    },]
  }
];


@NgModule({
  imports: [RouterModule.forChild(authRoutes), HttpClientModule],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
